var Backbone = require('backbone'),
    IndexView = require('../index/field');

module.exports = Marionette.CollectionView.extend({
	className: 'indexInfo',
    childView: IndexView
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/index/view/layout/collectionView.js
 ** module id = 575
 ** module chunks = 0
 **/